export const QUOTE_STORE_PATH = 'quote/'
